module.exports = __webpack_public_path__ + "img/img-error-emoji.6cfcb4b2.svg";